import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    console.log('Parallax eighth controller connected!')
    
    // Respect reduced motion
    this.prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)')
    if (this.prefersReduced.matches) {
      console.log('Reduced motion preferred, skipping parallax')
      return
    }

    this.left = this.element.querySelector('.v2-hero-bg-img-8')
    this.right = this.element.querySelector('.v2-right-panel-custom-8')
    if (!this.left || !this.right) {
      console.log('Could not find left or right elements for parallax')
      return
    }
    
    console.log('Found parallax elements, setting up...')

    const baseLeft = parseFloat(this.element.getAttribute('data-left-speed')) || 0.15
    const baseRight = parseFloat(this.element.getAttribute('data-right-speed')) || 0.3
    this.updateSpeeds(baseLeft, baseRight)

    this.ticking = false

    this._onScroll = this._onScroll.bind(this)
    this._onResize = this._onResize.bind(this)
    this._update = this._update.bind(this)

    // Only run when in view
    if ('IntersectionObserver' in window) {
      this.io = new IntersectionObserver((entries) => {
        const entry = entries[0]
        if (entry && entry.isIntersecting) {
          window.addEventListener('scroll', this._onScroll, { passive: true })
          window.addEventListener('resize', this._onResize)
          this._update()
        } else {
          window.removeEventListener('scroll', this._onScroll)
          window.removeEventListener('resize', this._onResize)
        }
      }, { root: null, threshold: 0 })
      this.io.observe(this.element)
    } else {
      // Fallback: always on
      window.addEventListener('scroll', this._onScroll, { passive: true })
      window.addEventListener('resize', this._onResize)
      this._update()
    }
  }

  disconnect() {
    if (this.io) this.io.disconnect()
    window.removeEventListener('scroll', this._onScroll)
    window.removeEventListener('resize', this._onResize)
  }

  _onResize() {
    const baseLeft = parseFloat(this.element.getAttribute('data-left-speed')) || 0.15
    const baseRight = parseFloat(this.element.getAttribute('data-right-speed')) || 0.3
    this.updateSpeeds(baseLeft, baseRight)
    this._onScroll()
  }

  updateSpeeds(baseLeft, baseRight) {
    const isSmall = window.innerWidth < 576
    this.leftSpeed = isSmall ? baseLeft * 0.6 : baseLeft
    this.rightSpeed = isSmall ? baseRight * 0.6 : baseRight
  }

  _onScroll() {
    if (!this.ticking) {
      window.requestAnimationFrame(this._update)
      this.ticking = true
    }
  }

  _update() {
    this.ticking = false
  // Use viewport-centered progress for clearer motion
  const rect = this.element.getBoundingClientRect()
  const centerOffset = (window.innerHeight / 2) - (rect.top + rect.height / 2)
  const leftY = this._clamp(centerOffset * this.leftSpeed, -120, 120)
  const rightY = this._clamp(centerOffset * this.rightSpeed, -160, 160)
    this.left.style.transform = `translate3d(0, ${leftY}px, 0)`
    this.right.style.transform = `translate3d(0, ${rightY}px, 0)`
  }

  _pageOffsetTop(el) {
    let top = 0
    while (el) {
      top += el.offsetTop
      el = el.offsetParent
    }
    return top
  }

  _clamp(n, min, max) { return Math.max(min, Math.min(n, max)) }
}
